export const activityMockData = [
  { "price": { "amount": 25 }, "minimumDuration": "1hr 30m", "rating": 7.5, "reviews": 120 },
  { "price": { "amount": 40 }, "minimumDuration": "2hr 30m", "rating": 8.4, "reviews": 245 },
  { "price": { "amount": 60 }, "minimumDuration": "2hr", "rating": 9.0, "reviews": 430 },
  { "price": { "amount": 12 }, "minimumDuration": "1hr", "rating": 6.0, "reviews": 75 },
  { "price": { "amount": 75 }, "minimumDuration": "3hr 30m", "rating": 9.5, "reviews": 320 },
  { "price": { "amount": 18 }, "minimumDuration": "50m", "rating": 6.8, "reviews": 150 },
  { "price": { "amount": 55 }, "minimumDuration": "2hr 45m", "rating": 8.8, "reviews": 280 },
  { "price": { "amount": 85 }, "minimumDuration": "1hr 20m", "rating": 9.2, "reviews": 500 },
  { "price": { "amount": 30 }, "minimumDuration": "40m", "rating": 7.0, "reviews": 90 },
  { "price": { "amount": 22 }, "minimumDuration": "1hr 20m", "rating": 7.3, "reviews": 130 },
  { "price": { "amount": 48 }, "minimumDuration": "2hr 30m", "rating": 8.6, "reviews": 210 },
  { "price": { "amount": 33 }, "minimumDuration": "1hr 45m", "rating": 7.2, "reviews": 110 },
  { "price": { "amount": 66 }, "minimumDuration": "1hr 40m", "rating": 8.9, "reviews": 270 },
  { "price": { "amount": 14 }, "minimumDuration": "40m", "rating": 6.5, "reviews": 60 },
  { "price": { "amount": 29 }, "minimumDuration": "1hr 10m", "rating": 7.1, "reviews": 100 }
];
